import React from "react";
import type { TFaqLang } from "@/src/features/faq/types";

interface IFaqLangToggleProps {
  lang: TFaqLang;
  onChange: (lang: TFaqLang) => void;
  /** `sm` uses the short EN / বাং labels from the design. */
  size?: "sm" | "md";
  className?: string;
}

const OPTIONS: { value: TFaqLang; long: string; short: string }[] = [
  { value: "en", long: "English", short: "EN" },
  { value: "bn", long: "বাংলা", short: "বাং" },
];

/** English / বাংলা switch for the FAQ surfaces. */
const FaqLangToggle: React.FC<IFaqLangToggleProps> = ({
  lang,
  onChange,
  size = "md",
  className = "",
}) => (
  <div
    className={`flex flex-none rounded-full ${
      size === "sm" ? "gap-1 p-[3px]" : "gap-[5px] p-1"
    } bg-neutral-100 ${className}`}
  >
    {OPTIONS.map((option) => {
      const isActive = lang === option.value;
      return (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          aria-pressed={isActive}
          lang={option.value === "bn" ? "bn" : "en"}
          className={`faq-swap cursor-pointer whitespace-nowrap rounded-full border-none font-semibold ${
            size === "sm"
              ? "px-[13px] py-[7px] text-12"
              : "px-4 py-2.5 text-12 md:px-5 md:text-13"
          } ${
            isActive
              ? "bg-white text-brand-600 shadow-[0_3px_10px_-4px_rgba(60,20,35,0.3)]"
              : "bg-transparent text-ink-muted"
          }`}
        >
          {size === "sm" ? option.short : option.long}
        </button>
      );
    })}
  </div>
);

export default FaqLangToggle;
